import Alpine from 'alpinejs';
import {RelatedPostsSlider} from "./components/relatedPost";
import {GForms} from "./components/GForms";
import {ApplyAnchor} from "./components/ApplyAnchor";

window.Alpine = Alpine;

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    RelatedPostsSlider().init();
    GForms().init();
    ApplyAnchor().init();
});
